import React from "react";

import myImage from "./search64px.svg";

export default function CurrentWeatherImage() {
  return <img src={myImage} alt="search icon" />;
}
